import React, { useState } from 'react';
import { message, Tooltip } from 'antd';
import useJoinVerifyPlusStatus from 'hooks/useJoinVerifyPlusStatus';
import JoinVerifyPlusModal from './JoinVerifyPlusModal';
import s from './s.module.less';

import bannerBg from 'assets/home/verifyPlus/banner-bg.png';
import bannerIllustration from 'assets/home/verifyPlus/banner.png';
import avatarImg from 'assets/home/verifyPlus/avatar2.png';

type Props = {
    onClose: () => void;
};

const JoinVerifyPlusBanner = ({ onClose }: Props) => {
    const [statusData, , fetchStatus] = useJoinVerifyPlusStatus();
    const [showModal, setShowModal] = useState(false);

    const handleJoinSuccess = () => {
        setShowModal(false);
        message.success('You have opted-in the 1-month Klarity Verified Plus test successfully.');
        fetchStatus();
    };

    if (!statusData || !statusData.eligible) {
        return null;
    }

    const { status, canJoin, joinedPracticeCount } = statusData;
    const isActive = status === 'ACTIVE';
    const canShowJoin = !isActive && canJoin;
    const canShowDisabledJoin = !isActive && !canJoin;

    return (
        <>
            <div className={s.wrap} style={{ backgroundImage: `url(${bannerBg})` }}>
                <div className={s.left}>
                    <img src={bannerIllustration} alt="" className={s.illustration} />
                </div>
                <div className={s.center}>
                    <div className={s.title}>
                        <span className={s.emoji}>🎖</span> Klarity <span className={s.highlight}>Verified Plus</span>{' '}
                        is open to your practice
                    </div>
                    <div className={s.des}>
                        Every new patient adds a valid payment card before booking, so copays and balances can be
                        charged to a card that&apos;s already there. One-month test, and every new-patient booking is
                        billable.
                    </div>
                </div>
                <div className={s.right}>
                    <img src={avatarImg} alt="" className={s.avatarImg} />
                    <div className={s.joinedCount}>{joinedPracticeCount} practices joined</div>
                    {isActive && <div className={s.joinedBadge}>Joined</div>}
                    {canShowJoin && (
                        <span className={s.joinBtn} onClick={() => setShowModal(true)}>
                            Join now
                        </span>
                    )}
                    {canShowDisabledJoin && (
                        <Tooltip title="This program is joined per practice. Ask your practice owner to join.">
                            <span className={`${s.joinBtn} ${s.disabled}`}>Join now</span>
                        </Tooltip>
                    )}
                </div>
                <span className={s.close} onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path
                            d="M1 13L13 1M1 1L13 13"
                            stroke="#4B5563"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </span>
            </div>
            <JoinVerifyPlusModal
                open={showModal}
                onCancel={() => setShowModal(false)}
                onJoinSuccess={handleJoinSuccess}
            />
        </>
    );
};

export default JoinVerifyPlusBanner;
